import { Link } from 'react-router-dom';
import { blogArticles } from '@/mocks/categories';

export default function ArticleCardsSection() {
  return (
    <section className="bg-background-50 py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row lg:items-end gap-4 mb-12">
          <div className="flex-1">
            <h2 className="text-3xl md:text-5xl font-heading text-foreground-950 leading-tight">
              Latest SEO Guides
            </h2>
          </div>
          <p className="text-sm text-foreground-500 max-w-md lg:text-right">
            Expert guides and resources to help you master Kakobuy spreadsheet shopping
            and discover the best product finds.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {blogArticles.map((article, idx) => (
            <div key={article.title}>
              {idx === 0 ? (
                <Link
                  to={article.slug}
                  className="block group relative rounded-2xl overflow-hidden bg-primary-800 h-full min-h-[380px] cursor-pointer"
                >
                  <img
                    src={article.image}
                    alt={article.title}
                    className="absolute inset-0 w-full h-full object-cover object-top opacity-40 group-hover:opacity-50 group-hover:scale-105 transition-all duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-primary-900/90 via-primary-900/40 to-transparent"></div>
                  <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
                    <span className="inline-block px-2.5 py-1 bg-accent-500 text-background-50 text-xs rounded-full mb-3">
                      {article.tag}
                    </span>
                    <h3 className="text-lg md:text-xl font-heading text-background-50 mb-2">{article.title}</h3>
                    <p className="text-xs text-background-50/60 mb-4">{article.excerpt}</p>
                    <span className="inline-flex items-center gap-1.5 text-xs font-medium text-background-50 bg-background-50/10 px-4 py-2 rounded-full group-hover:bg-background-50/20 transition-colors">
                      Read Article <i className="ri-arrow-right-line"></i>
                    </span>
                  </div>
                </Link>
              ) : (
                <div className="block group bg-background-100 rounded-2xl overflow-hidden h-full min-h-[380px] cursor-pointer">
                  <div className="relative h-44 overflow-hidden">
                    <img
                      src={article.image}
                      alt={article.title}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    />
                  </div>
                  <div className="p-5 md:p-6">
                    <span className="inline-flex items-center gap-1 text-xs text-accent-600 bg-accent-100/70 px-2.5 py-1 rounded-full mb-3">
                      <i className="ri-time-line"></i> {article.tag}
                    </span>
                    <h3 className="text-base md:text-lg font-heading text-foreground-900 mb-2">{article.title}</h3>
                    <p className="text-xs text-foreground-500 mb-4">{article.excerpt}</p>
                    {article.slug !== '#' ? (
                      <Link
                        to={article.slug}
                        className="inline-flex items-center gap-1.5 text-xs font-medium text-background-50 bg-primary-500 px-3.5 py-2 rounded-full hover:bg-primary-600 transition-colors"
                      >
                        Read Article <i className="ri-arrow-right-line"></i>
                      </Link>
                    ) : (
                      <span className="inline-flex items-center gap-1.5 text-xs font-medium text-background-50 bg-primary-500 px-3.5 py-2 rounded-full opacity-70">
                        Coming Soon
                      </span>
                    )}
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/blog/kakobuy-spreadsheet-ultimate-guide-2026"
            className="inline-flex items-center gap-2 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap"
          >
            View All Guides <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}